const INVALID_TOKEN_MESSAGE = 'Invalid or expired token';

/** Set by UserProvider so the API client can clear session without React context. */
let onInvalidToken: (() => void) | null = null;

export function setAuthExpiredHandler(handler: (() => void) | null): void {
  onInvalidToken = handler;
}

/**
 * When the API returns 403 with the standard invalid-token body, run the registered logout.
 * Safe to call with any response shape.
 */
export function notifyIfInvalidTokenResponse(status: number, body: unknown): void {
  if (status !== 403 || !onInvalidToken) return;
  let message = '';
  if (body && typeof body === 'object' && 'message' in body) {
    const m = (body as { message: unknown }).message;
    if (typeof m === 'string') message = m;
  }
  if (message === INVALID_TOKEN_MESSAGE) {
    onInvalidToken();
  }
}
